import { RootState } from '@src/reducers';
import { Actions } from '@src/constants/Constants';

export namespace AlertActions {

    export function hide() {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: Actions.HIDE_ALERT});
        };
    }

    export function show(msg: string) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: Actions.SHOW_ALERT, payload: msg });
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/AlertActions.ts